module.exports = __webpack_public_path__ + "static/font-366e1bf04ce045e2d95482c48fd40032.woff2";